<template>
  <FriedCard
    v-click-outside="handleClickOutside"
    class="mention-prospects-container"
    :style="{ top: top + 'px' }"
  >
    <FriedDropdownItem
      v-for="(mp, index) in mentionParticipants"
      :key="index"
      @click="$emit('add-mention', mp.commentParticipant)"
    >
      {{ `@${mp.fullName}` }}
    </FriedDropdownItem>
  </FriedCard>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import type { MentionParticipant } from '../types/mention-participant';

export default defineComponent({
  props: {
    mentionParticipants: {
      type: Array as PropType<MentionParticipant[]>,
      required: true,
    },
    top: {
      type: Number,
      default: 10,
    },
  },
  emits: ['add-mention', 'close'],
  setup(_, { emit }) {
    const handleClickOutside = () => {
      emit('close');
    };
    return {
      handleClickOutside,
    };
  },
});
</script>

<style lang="scss" scoped>
.mention-prospects-container {
  position: absolute;
  background-color: white;
  z-index: 1;
  left: 0;
  width: 300px;
  padding: var(--spacing-50);
}
</style>
